import dynamic from 'next/dynamic';
import { InferGetServerSidePropsType } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import atob from 'atob';
import { getPageTour } from '@/services/tour';
import LoadingProgress from '@/components/common/LoadingProgress';

const DynamicComponent3WithNoSSR = dynamic(() => import('../../components/Analytics'), {
  loading: () => <LoadingProgress />,
  ssr: false,
});

export const getServerSideProps = async (context: { query: { hashedId: string }; req: any }) => {
  const { hashedId } = context.query;
  const slug = atob(decodeURIComponent(hashedId));

  const tourData = await getPageTour({
    slug,
    origin: context.req.headers.host,
  });
  const data = JSON.stringify(tourData);

  return {
    props: {
      data,
    },
  };
};

const IndexPage = ({ data }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const { title, description, tourImage, website, faviconUrl, slug, charset } = JSON.parse(data);
  const router = useRouter();
  const { hashedId } = router.query;
  return (
    <div>
      <Head>
        <title>{title}</title>
        <meta property="og:description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={tourImage} />
        <meta property="og:image:secure_url" content={tourImage} />
        <meta property="og:image:width" content="640" />
        <meta property="og:image:height" content="442" />
        <meta property="og:url" content={`https://${website}/analytics/${slug}`} />
        <meta charSet={charset} />
        <link rel="stylesheet" href="https://static.treedis.com/fontawesome/5.15.3/css/all.min.css" />
        {faviconUrl && <link rel="icon" href={`${faviconUrl}`} />}
        <script type="text/javascript" src="https://maps.googleapis.com/maps/api/js?key=AIzaSyAxJYg1iR0WMy4vpFa3zB7E0Dx7lz8h5dk&libraries=places" />
      </Head>
      <DynamicComponent3WithNoSSR hashedId={hashedId} slug={slug} reactAws={process.env.REACT_APP_AWS} />
    </div>
  );
};

export default IndexPage;
